<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                style="width: 100%"
                src="@//assets/images/pages/StadiumRegistro.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <img
                    src="/logo-stadium.png"
                    style="max-width: 200px; width: 100%; margin-bottom: 20px"
                  />
                  <h4 class="mb-4">Login</h4>
                  <p>
                    Bienvenido de nuevo, por favor identificate para entrar.
                  </p>
                </div>

                <login-jwt></login-jwt>

                <div class="vx-card__title mb-4">
                  <br />
                  ¿No tienes cuenta?
                  <a
                    href="https://pagos.stadiumcasablanca.com/app.php?a=registro-general"
                    target="_blank"
                    >Regístrate</a
                  >
                  <br />
                  <a
                    href="https://pagos.stadiumcasablanca.com/loginPassRecordar.php"
                    target="_blank"
                    >Recordar contraseña</a
                  >
                  <div style="margin-top: 20px; margin-bottom: 20px">
                    <span
                      >Copyright &copy; {{ new Date().getFullYear() }}
                      <a
                        href="https://stadiumcasablanca.com/"
                        target="_blank"
                        rel="nofollow"
                        >Stadium Casablanca</a
                      >, All rights Reserved -
                      <a
                        href="http://www.stadiumcasablanca.com/aviso-legal/"
                        target="_blank"
                        >Aviso legal</a
                      >
                      -
                      <a
                        href="https://stadiumcasablanca.com/terminos-de-uso/"
                        target="_blank"
                        >Términos y condiciones</a
                      >
                      -
                      <a
                        href="https://stadiumcasablanca.com/politica-de-privacidad-club-deportivo-stadium-casablanca/"
                        target="_blank"
                        >Política de privacidad</a
                      ></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import LoginJwt from "./LoginJWT.vue";

export default {
  components: {
    LoginJwt,
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");
    if (token && token !== "" && email && email !== "") {
      this.loginJWTToken(email, token);
    }
  },
  methods: {
    loginJWTToken(email, token) {
      // Loading
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: email,
          token: token,
        },
      };

      this.$store
        .dispatch("auth/loginJWTToken", payload)
        .then(() => {
          this.$acl.change(localStorage.getItem("userRole"));

          // Navigate User to homepage
          //router.push(router.currentRoute.query.to || '/')
          window.location = "/home";
          //this.$router.push('/home')
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.layout--full-page .full-page-bg-color {
  background-color: #00ac20;
}
</style>
